import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination';

import { DebtService } from '../_Services/debt.service';
import { CommonService } from '../_Services/common.service';

@Component({
  templateUrl: 'assigned.component.html'
})
export class AssignedComponent {

    debts = [];  
    p: any = 1;  
    paginator = []; 
    model: any = { ofs: ''};
    ofs = [];
	constructor(private debtService: DebtService, private commonService: CommonService) { }

    changeShape(shape){
        console.log(shape);
        this.model.product = shape;
    } 
    
   

	pageChanged(page: Number) {
		if(page == undefined) {
            page = 1;
        }
        this.p = page; 
	    this.debtService.getAgencyAssignments(page, this.model).subscribe(result => {
                console.log(result);
                this.debts = result.assignments;
                this.paginator = result.paginator; 
            });
	}

	ngOnInit() { 
		// common ofs
        this.commonService.getOfs().subscribe(result => {
                 
                this.ofs = result;
            });  
	    this.debtService.getAgencyAssignments(this.p, null).subscribe(result => {
                console.log(result);
                this.debts = result.assignments;
                this.paginator = result.paginator; 
            }); 
	}
}


// WEBPACK FOOTER //
// ./src/app/agencies/assigned.component.ts